import { Modal, UploadFile } from "antd";
import { useRef, useState } from "react";
import { FontPreviewCard } from "../../brandkit/components/FontPreview";
import { AssetUploader } from "pages/asset-libraries/AssetUploader/";
import { CREATE_ASSET_REQUEST_TYPE } from "pages/asset-libraries/AssetLibraryDetail/";
import { AssetSource, MediaAsset } from "../../types";
import { UploadFilesRef } from "components/uploader/UploadFiles/";
import styled from "styled-components";

export const FontUploadModal = ({
  openFontsUploadModal,
  setOpenFontsUploadModal,
  organizationId,
  assetLibraryId,
  onUploadFontComplete,
}: {
  openFontsUploadModal: boolean;
  setOpenFontsUploadModal: React.Dispatch<React.SetStateAction<boolean>>;
  organizationId: string;
  assetLibraryId: string;
  onUploadFontComplete: (assets: Partial<MediaAsset>[]) => void;
}) => {
  const [isUploadingFonts, setIsUploadingFonts] = useState(false);
  const uploadFontsRef = useRef<UploadFilesRef>(null);
  const uploadFontProps = {
    ref: uploadFontsRef,
    acceptedMimeTypes: "font/ttf, .ttf",
    itemRequestProperties: (file: File) => ({
      type: CREATE_ASSET_REQUEST_TYPE,
      organization_id: organizationId,
      category: "Font" as const,
      description: file?.name,
      source: AssetSource.UIGenerated,
      asset: {
        type: "Font" as const,
      },
    }),
    renderPreview: (file: UploadFile) => {
      return (
        <FontPreviewCard
          key={file.uid}
          title={"Font"}
          font={file.originFileObj}
        />
      );
    },
    maxFileSize: 120,
  };
  return (
    <Modal
      open={openFontsUploadModal}
      onCancel={(e) => {
        e.stopPropagation();
        setOpenFontsUploadModal(false);
      }}
      okButtonProps={{
        loading: isUploadingFonts,
        disabled: isUploadingFonts,
      }}
      closable={false}
      onOk={(e) => {
        e.stopPropagation();
        setIsUploadingFonts(true);
        uploadFontsRef.current
          ?.upload(`media/asset_libraries/${assetLibraryId}/assets`)
          .then(() => {
            setOpenFontsUploadModal(false);
            uploadFontsRef.current?.reset();
          })
          .catch((error) => {
            console.error("Error uploading font", error);
          })
          .finally(() => {
            setIsUploadingFonts(false);
          });
      }}
      wrapClassName="font-upload-modal"
      afterOpenChange={(open) => {
        if (open) {
          const modalElement = document.querySelector(
            ".ant-modal-wrap.font-upload-modal"
          );
          if (modalElement) {
            (modalElement as HTMLElement).setAttribute("data-interactive", "");
          }
        }
      }}
    >
      <UploaderWrapper data-interactive>
        <AssetUploader
          uploadProps={uploadFontProps}
          onUploadComplete={onUploadFontComplete}
        />
      </UploaderWrapper>
    </Modal>
  );
};

const UploaderWrapper = styled.div`
  .ant-upload-list {
    gap: 0 !important;
    .ant-upload-list-item-container {
      margin-right: 10px !important;
    }
  }
`;
